import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

interface BtnContainerProps {
    color: string;
    width?: number;
    height?: number;
    checked?: boolean;
}

export const BtnContainer = styled.div<BtnContainerProps>`
    position: relative;
    border-radius: 8px;
    background-color: ${props => { return palette(props.color) }};
    border: 1px solid ${palette('gray_opacity_200')};
    ${props => {
        if (props.color === 'gray_opacity_50') {
            return css``;
        }
    }}
    width: ${props => props.width ? props.width : `44`}px;
    height: ${props => props.height ? props.height : `44`}px;

    > svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
`;

export const BtnColor = styled.input`
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    margin: 0;
`;